export default __webpack_public_path__ + "assets/images/Pie Chart-78bcafb5584035ff2860a6319007a48d.svg";